import React, {useEffect, useState} from "react";
import { isMobile } from "react-device-detect";
import PullToRefresh from "react-simple-pull-to-refresh";
import { GET } from "../axios/networkFetch";
import "./LeaderBoard.css";
import Loader from "./Loader";

const LeaderBoard = () => {

  const [leaderboardData, setLeaderboardData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);

  const getLeaderBoard = async () => {
    const data = await GET("https://api.theox.co/v2/reward/leaderboard");
    if (data?.data?.success){
      setLeaderboardData(data?.data?.leaderboard);
    }
    setShowLoader(false);
  };

  const handleRefresh = async (e) => {
    getLeaderBoard();

  };

  useEffect(() => {
    getLeaderBoard();
  }, []);

  return (
      <div style={{height: "100%"}}>
        {showLoader ? (<Loader />)
        : (    <PullToRefresh
                onRefresh={handleRefresh}
                pullingContent=""
                isPullable={isMobile}
            >
              <div
                  className="parent"
                  style={{
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    flex: 1,
                    alignSelf: "center",
                    padding: 50,
                    marginBottom: 100
                  }}
              >
                <table>
                  <tr>
                    <th>Rank</th>
                    {/* <th>Ankit</th> */}
                    <th style={{ width: window.innerWidth / 2.5, textAlign: "left" }}>
                      User Details
                    </th>
                    <th>Zone</th>
                    <th>Total Vol</th>
                  </tr>
                  <tr>
                    <td colSpan={4} className="rowText">
                      Rank 1: 200 USDT I Rank 2: 100 USDT I Rank 3: 50 USDT I Rank 4-10:
                      20 USDT I Rank 11-50: 10 USDT
                    </td>
                  </tr>

                  {leaderboardData?.map((item) => {
                    return (
                        <tr className="internalRow">
                          <td>
                            <div>
                              <p>{item?.rank}</p>
                            </div>
                          </td>
                          <td
                              style={{
                                width: window.innerWidth / 2.5,
                                textOverflow: "ellipsis",
                                paddingLeft: "6px",
                                paddingRight: "6px",
                              }}
                          >
                            {item?.userDetails}
                          </td>
                          <td>
                            {item?.zone ? (<div>
                              <p></p>
                            </div>)
                            : (<div style={{background: "#F23645"}}>
                                  <p></p>
                                </div>)}
                          </td>
                          <td>{item?.vol}</td>
                        </tr>
                    );
                  })}
                </table>
              </div>
            </PullToRefresh>)}
      </div>
  );
};

export default LeaderBoard;
